import React, { useState, useEffect } from "react";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import DataTable from "react-data-table-component";
import { get, post } from "../../services/api";
import Select from "react-select";
import { toast } from "react-toastify";
import { customTableStyles } from "../../assets/CustomTableStyles";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import logo from "../../assets/img/logo-full.png";

function ParentQuestionerFormList() {
  const token = localStorage.getItem("token");
  const organizationId = localStorage.getItem("organizationId");
  const navigate = useNavigate();
  const [triggerRerender, setTriggerRerender] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const savedCenterId =
    localStorage.getItem("centerId") === "null"
      ? null
      : localStorage.getItem("centerId");

  const {
    register,
    formState: { errors, isSubmitting },
    control,
    handleSubmit,
    watch,
    setValue,
    getValues,
    trigger,
    reset,
    setError,
  } = useForm({
    defaultValues: {
      name: "",
      description: "",
      createdBy: localStorage.getItem("userId"),
      organizationId: organizationId,
    },
  });

  const [questionerFormData, setQuestionerFormData] = useState([]);

  const getQuestionerFormList = async () => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }

    try {
      const response = await get(
        `Registration/GetParentQuestionerByCenterId?&centerId=${savedCenterId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setQuestionerFormData(response.parentQuestioner);
    } catch (error) {
      console.error("Error fetching classes:", error);
    }
  };

  useEffect(() => {
    getQuestionerFormList();
  }, [triggerRerender]);
  const handleEdit = (row) => {
    navigate(`/parent-questionnaire-form?id=${row.id}`);
  };
  // const handleEdit = async (row) => {
  //   try {
  //     const singleClassData = await get(
  //       `Registrations/GetParentQuestionerById?Id=${row.id}`,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );

  //     reset({
  //       ...singleClassData,
  //       id: singleClassData.id,
  //       updatedBy: localStorage.getItem("userId"),
  //     });
  //   } catch (error) {
  //     console.error("Error editing section:", error);
  //   }
  // };

  const handleDelete = async (rowId) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this Question?"
    );

    if (confirmDelete) {
      const formData = {
        id: rowId,
        isDelete: true,
        deletedBy: localStorage.getItem("userId"),
      };

      try {
        const response = await post(`Class/DeleteClassById`, formData, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.isSuccess) {
          toast.success(response.message || "Success!");
          setTriggerRerender((prev) => !prev);
        } else {
          toast.error(response.message || "An error occurred while deleting.");
        }
      } catch (error) {
        console.error("Error deleting category:", error);
      }
    }
  };

  const columns = [
    {
      name: "Sr No.",
      cell: (row, index) => (currentPage - 1) * rowsPerPage + index + 1,
      sortable: false,
      width: "60px",
    },
    {
      name: "Name",
      selector: (row) => row.studentName,
      sortable: true,
      width: "150px",
    },
    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
      width: "200px",
    },
    {
      name: "Action",
      width: "80px",
      selector: (row) => (
        <div className="d-flex gap-1">
          <button
            type="button"
            className="btn p-0"
            onClick={() => handleEdit(row)}
          >
            <i className="fas fa-pencil"></i>
          </button>
          <button
            type="button"
            className="btn p-0"
            onClick={() => handleDelete(row.id)}
          >
            <i className="fas fa-trash"></i>
          </button>
        </div>
      ),
    },
  ];

  const exportToExcel = () => {
    const filteredData = questionerFormData.map((row, index) => ({
      "Sr No": index + 1,
      Name: row.name,
      Description: row.description,
      // ID: row.id,
    }));

    console.log(filteredData);
    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Classes");
    XLSX.writeFile(workbook, "ParentQuestionerList.xlsx");
  };

  const exportToPDF = () => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const logoWidth = 30;
    const logoHeight = 8;
    const logoX = (pageWidth - logoWidth) / 2;
    const logoY = 10;
    doc.addImage(logo, "PNG", logoX, logoY, logoWidth, logoHeight);

    const title = "Parent Questionnaire List";
    const titleFontSize = 12;
    doc.setFontSize(titleFontSize);
    doc.setFont("helvetica", "bold");
    const textWidth = doc.getTextWidth(title);
    const titleX = (pageWidth - textWidth) / 2;
    const titleY = logoY + logoHeight + 10;
    doc.text(title, titleX, titleY);

    const includedColumns = columns.filter((column) => !column.omit);

    const headers = includedColumns
      .filter((col) => col.name !== "ID" && col.name !== "Action")
      .map((col) => col.name);

    const bodyData = questionerFormData.map((row, index) => {
      return [
        (currentPage - 1) * rowsPerPage + index + 1,
        ...includedColumns
          .filter(
            (column) =>
              column.name !== "ID" &&
              column.name !== "Action" &&
              column.name !== "Sr No."
          )
          .map((column) => (column.selector ? column.selector(row) : "")),
      ];
    });

    doc.autoTable({
      head: [headers],
      body: bodyData,
      theme: "striped",
      startY: titleY + 10,
      headStyles: {
        fillColor: [144, 84, 255],
        textColor: [255, 255, 255],
      },
    });

    doc.save("ParentQuestionerList.pdf");
  };

  useEffect(() => {
    const tooltipTriggerList = Array.from(
      document.querySelectorAll('[data-bs-toggle="tooltip"]')
    );
    tooltipTriggerList.forEach((tooltipTriggerEl) => {
      new window.bootstrap.Tooltip(tooltipTriggerEl);
    });
  }, []);

  return (
    <>
      <div className="page-header d-flex mb-2">
        <h2 className="page-heading mb-2 fs-7">Parent Questionnaire List</h2>
      </div>
      <div className="row g-3">
        <div className="col-md-5">
          <div className="card">
            <div className="card-body">
              <div
                className="d-flex justify-content-end"
                style={{ marginTop: 0 }}
              >
                <div className="d-flex align-items-start gap-1">
                  <button
                    type="button"
                    data-bs-toggle="tooltip"
                    data-bs-custom-class="custom-tooltip"
                    title="Export to Excel"
                    className="btn btn-outline-success px-2 py-1"
                    onClick={exportToExcel}
                  >
                    <i className="fs-8 fa fa-file-excel"></i>
                  </button>
                  <button
                    type="button"
                    data-bs-toggle="tooltip"
                    data-bs-custom-class="custom-tooltip"
                    title="Export to PDF"
                    className="btn btn-outline-danger px-2 py-1"
                    onClick={exportToPDF}
                  >
                    <i className="fs-8 fa fa-file-pdf"></i>
                  </button>
                </div>
              </div>
              <div className="table-container fixed-last-column-table">
                <DataTable
                  columns={columns}
                  data={questionerFormData}
                  pagination
                  paginationPerPage={rowsPerPage} // Make sure this is controlled by your state
                  paginationRowsPerPageOptions={[10, 20, 30, 40, 50]} // Add this line
                  dense
                  customStyles={customTableStyles}
                  highlightOnHover={true}
                  onChangePage={setCurrentPage}
                  onChangeRowsPerPage={setRowsPerPage}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default ParentQuestionerFormList;
